import React from "react";
import trans, { isRTL } from "../../../../utils";

export default function HeatMapPopupHead({ total }) {
  return (
    <div className="device-popup-head" dir={isRTL ? "rtl" : "ltr"}>
      <div className="device-popup-name">
        {trans("POIs Number")}: {total}
      </div>
    </div>
  );
}
